import apiFactory from '../../services/apiFactory';
import { identifyDevice, trackEvent } from '../../utils/mixpanelUtil';

export const getFoodCategories = (params) => {
  return new Promise((resolve, reject) => {
    apiFactory.get(`vendors/food-categories?${params.join('&')}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Food categories', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data);
      },
      (error) => {
        identifyDevice();
        trackEvent('VendorFoodCategories', {
          action_category: 'Retrieve Food Categories',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const getVendors = (
  page = 1,
  latitude = 41.328939,
  longitude = 19.813715,
  orderBy,
  orderDirection,
  perPage = 15,
  filterKeys
) => {
  const params = [`lat=${latitude}`, `lng=${longitude}`, `page=${page}`, `per_page=${perPage}`];
  if (orderBy) {
    params.push(`ordering_attribute=${orderBy}`);
    params.push(`ordering_order=${orderDirection}`);
  }

  if (!!filterKeys && filterKeys.length > 0) {
    for (let i = 0; i < filterKeys.length; i++) {
      params.push(filterKeys[i]);
      if (filterKeys[i].includes('ordering_attribute')) {
        params.push('ordering_order=1');
      }
    }
  }

  return new Promise((resolve, reject) => {
    apiFactory.get(`vendors?${params.join('&')}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Vendors', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.vendors);
      },
      (error) => {
        identifyDevice();
        trackEvent('Load Vendors', {
          action_category: 'Load Screen',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const getVendorDetail = (id, latitude = 41.328939, longitude = 19.813715, order_method) => {
  let url = `vendors/${id}?lat=${latitude}&lng=${longitude}`;
  if (order_method != null) {
    url = `${url}&order_method=${order_method}`;
  }
  return new Promise((resolve, reject) => {
    apiFactory.get(url).then(
      ({ data }) => {
        resolve(data.vendor);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getFeaturedBlocks = (latitude = 41.328939, longitude = 19.813715, filterKeys) => {
  const params = [`lat=${latitude}`, `lng=${longitude}`];

  if (!!filterKeys && filterKeys.length > 0) {
    for (let i = 0; i < filterKeys.length; i++) {
      params.push(filterKeys[i]);
    }
  }

  return new Promise((resolve, reject) => {
    apiFactory.get(`vendors/mobile-feature-blocks?${params.join('&')}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Mobile feature blocks', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screeb',
          source: 'sf_web'
        });
        resolve(data.result);
      },
      (error) => {
        identifyDevice();
        trackEvent('Load Mobile feature blocks', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screeb',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const getVendorFavourites = () => {
  return new Promise((resolve, reject) => {
    apiFactory.get('vendors/favourites').then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Vendors favourites', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.vendors);
      },
      (error) => {
        identifyDevice();
        trackEvent('VendorFavourites', {
          action_category: 'Retrieve Vendor favourites',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const getProductFavourites = () => {
  return new Promise((resolve, reject) => {
    apiFactory.get('products/favourites').then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Products favourites', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.products);
      },
      (error) => {
        identifyDevice();
        trackEvent('Load Products favourites', {
          action_category: 'Load Screen',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const toggleFavourite = (vendorId, isFavourite) => {
  return new Promise((resolve, reject) => {
    apiFactory
      .post('vendors/favourites', {
        vendor_id: vendorId,
        favourite: isFavourite
      })
      .then(
        () => {
          identifyDevice();
          trackEvent('VendorFavourites', {
            action_category: 'Add Vendor favourites',
            action_outcome: 'success',
            interaction_element: 'toggle',
            source: 'sf_web'
          });
          resolve();
        },
        (error) => {
          identifyDevice();
          trackEvent('VendorFavourites', {
            action_category: 'Add Vendor favourites',
            action_outcome: 'fail',
            interaction_element: 'toggle',
            source: 'sf_web'
          });
          reject(error);
        }
      );
  });
};

export const toggleProductFavourite = (productId, isFavourite) => {
  return new Promise((resolve, reject) => {
    apiFactory
      .post('products/favourites', {
        product_id: productId,
        favourite: isFavourite
      })
      .then(
        () => {
          identifyDevice();
          trackEvent('ProductFavourites', {
            action_category: 'Create Product favourites',
            action_outcome: 'success',
            interaction_element: 'button clicking',
            source: 'sf_web'
          });
          resolve();
        },
        (error) => {
          identifyDevice();
          trackEvent('ProductFavourites', {
            action_category: 'Create Product favourites',
            action_outcome: 'fail',
            interaction_element: 'button clicking',
            source: 'sf_web'
          });
          reject(error);
        }
      );
  });
};

export const checkVendorOpen = (id) => {
  let url = `check-vendor-open/${id}`;
  return new Promise((resolve, reject) => {
    apiFactory.get(url).then(
      ({ data }) => {
        resolve(data.vendor_open == 1);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
